import React, { useMemo, useEffect, useState, useCallback } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { RotatingLines, Bars } from "react-loader-spinner";
import GLOBALS from "../../utils/Globals";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileAction } from "../../redux/slices/users/usersSlice";
import { Tabs, Tab, Container, Row, Col, Image, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import ImageWithSpinner from "../../utils/ImageWithSpinner";

export default function ImageCard({ url }) {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', height: '100%' }}>
      <ImageWithSpinner imageUrl={url} />
    </div>
  );
}
